import type { EmptyTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const emptyDark: EmptyTheme = {
  name: 'Empty',
  common: commonDark,
  self
}

export default emptyDark
